var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-rect',{attrs:{"stroke-width":0,"fill":"#606266"}})}
var staticRenderFns = []

export { render, staticRenderFns }